import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Our Skills</h2>
              <p>
                Expert in crafting unique brand identities, designing
                eye-catching logos, Skilled in digital graphics, creative
                direction, and visual storytelling to enhance brand presence.
                Proficient in Adobe Creative Suite and modern design trends.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Brand Identity</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Simple & clear design</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Visual Identity </h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5> Typography Harmony</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Color Psychology </h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Layout & Composition </h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>User Experience</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} />
    </section>
  );
};
